var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useToggle } from '@hn-front/utils';
import { styled } from 'styled-components';
import { format, parseISO } from 'date-fns';
import { LinkButton } from '@hn-ui/buttons';
import { Grades } from '@hn-front/data-types';
import { Edit } from '@hn-ui/icons';
import { Badge } from '../Badge';
import { CancelSection } from './CancelSection';
import { EditSection } from './EditSection';
import { TitleContainer, Description, ChallengeText, ChallengeTitle, ChallengeContainer, Controls, } from '../Common';
var ScDescription = styled(Description).withConfig({ displayName: "ScDescription", componentId: "sc-1nug9lt" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n"], ["\n  border-bottom: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black80;
});
var Scheduled = function (_a) {
    var id = _a.id, startDate = _a.startDate, endDate = _a.endDate, grades = _a.grades, author = _a.author, onCancel = _a.onCancel, onEdit = _a.onEdit, rest = __rest(_a, ["id", "startDate", "endDate", "grades", "author", "onCancel", "onEdit"]);
    var _b = useToggle(), isEdit = _b.isToggled, toggleEdit = _b.toggle;
    var start = format(parseISO(startDate), 'MMM dd');
    var end = format(parseISO(endDate), 'MMM dd');
    var gradesStr = grades.map(function (g) { return Grades[g].full; }).join(', ');
    var handleOnUpdateMarathon = useCallback(function (gradeValues) {
        onEdit({ id: id, grades: gradeValues });
        toggleEdit();
    }, [toggleEdit, id, onEdit]);
    return (_jsxs(ChallengeContainer, __assign({ color: 'blue60' }, rest, { children: [_jsxs(ScDescription, { children: [_jsxs(TitleContainer, { children: [_jsxs(ChallengeTitle, { children: [start, " - ", end] }, void 0), _jsx(Badge, { state: 'scheduled' }, void 0)] }, void 0), _jsxs(ChallengeText, { children: ["4-week Math Challenge for ", gradesStr] }, void 0), _jsxs(Controls, { children: [_jsxs(ChallengeText, { children: ["Started by ", author] }, void 0), isEdit ? (_jsx(LinkButton, __assign({ fit: true, onClick: toggleEdit }, { children: "Cancel editing" }), void 0)) : (_jsx(LinkButton, __assign({ LeftIcon: Edit, fit: true, onClick: toggleEdit }, { children: "Edit" }), void 0))] }, void 0)] }, void 0), !isEdit && _jsx(CancelSection, { onCancel: function () { return onCancel(id); } }, void 0), isEdit && (_jsx(EditSection, { startDate: startDate, endDate: endDate, onSave: handleOnUpdateMarathon, grades: grades }, void 0))] }), void 0));
};
export { Scheduled };
var templateObject_1;
